import * as S from './RadioCircle.styles'

export type RadioCircleProps = {
  checked?: boolean
}

export default function RadioCircle({ checked }: RadioCircleProps) {
  if (checked) {
    return (
      <S.OuterCircle $checked>
        <S.InnerCircle />
      </S.OuterCircle>
    )
  }

  return <S.OuterCircle />
}
